import styled from 'styled-components';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

export const SpreadFromMarkCellLabel = ({
  value,
}: {
  value: string | undefined;
}) => {
  if (value === undefined) {
    return null;
  }
  return (
    <>
      <br />
      <SecondaryLabel>{value}</SecondaryLabel>
    </>
  );
};

export const SecondaryLabel = styled.div`
  opacity: 0.4;
  color: white;
  font-weight: 600;
  font-size: 10px;
  letter-spacing: 0;
  line-height: 12px;
  margin-top: 1px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    text-align: end;
  }
`;
